import { render, staticRenderFns } from "./AddCredit.vue?vue&type=template&id=1cbc80a4&lang=pug&"
import script from "./AddCredit.vue?vue&type=script&lang=ts&"
export * from "./AddCredit.vue?vue&type=script&lang=ts&"
import style0 from "./AddCredit.vue?vue&type=style&index=0&id=1cbc80a4&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports